import React from 'react'
import './VersionsTable.scss'
import Ios from '../../../assets/platforms/ios.png'
import Android from '../../../assets/platforms/android.png'

import { VersionType } from '../../../types/app/versionTypes'


type Props = {
    versionsData: VersionType[]
    handleEdit: (data: VersionType) => void
}

const VersionsTable: React.FC<Props> = ({ versionsData, handleEdit }) => {


    return (
        <div className="versions-table-wrapper">
            <div className="versions-table">
                <div className="versions-header">
                    <div>Platform</div>
                    <div>Current version</div>
                    <div>Latest Version</div>
                    <div>Critical Update</div>
                    <div>Forced Update</div>
                    <div>Release Date</div>
                    <div>Effective Date</div>
                    <div></div>
                </div>

                {versionsData?.length >= 1 && versionsData.map(item => (
                    <div className="versions-row" key={item.id}>
                        <div className="platform-cell">
                            {item.platform === 'ios' ? (
                                <>
                                    <img src={Ios} alt="ios" className='platform-icon' />
                                    <span>App Store</span>
                                </>
                            ) : (
                                <>
                                    <img src={Android} alt="ios" className='platform-icon' />
                                    <span>Play Store</span>
                                </>
                            )}
                        </div>

                        <div className="version-cell">{item.version}</div>

                        <div className="version-cell muted">
                            {item.minimumSupportedVersion}
                        </div>

                        <div className="switch-cell">
                            <button
                                type="button"
                                className={`toggle ${item.isCritical ? "active" : ""}`}
                                aria-pressed={item.isCritical}
                            >
                                <span className="toggle-thumb">
                                    <svg
                                        width="30"
                                        height="33"
                                        viewBox="0 0 30 33"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g filter="url(#filter0_d)">
                                            <rect
                                                x="4"
                                                y="4"
                                                width="21.0843"
                                                height="24.3902"
                                                rx="10.5422"
                                                fill="white"
                                            />
                                            <path
                                                d="M19.0742 12.9297L12.8867 18.9297L10.0742 16.2024"
                                                stroke={`${item.isCritical ? "#00A759" : "black"}`}
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                    </svg>
                                </span>
                            </button>
                        </div>

                        <div className="switch-cell">
                            <button
                                type="button"
                                className={`toggle ${item.forceUpdate ? "active" : ""}`}
                                aria-pressed={item.forceUpdate}
                            >
                                <span className="toggle-thumb">
                                    <svg
                                        width="30"
                                        height="33"
                                        viewBox="0 0 30 33"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g filter="url(#filter0_d)">
                                            <rect
                                                x="4"
                                                y="4"
                                                width="21.0843"
                                                height="24.3902"
                                                rx="10.5422"
                                                fill="white"
                                            />
                                            <path
                                                d="M19.0742 12.9297L12.8867 18.9297L10.0742 16.2024"
                                                stroke={`${item.forceUpdate ? "#00A759" : "black"}`}
                                                strokeWidth="1.3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                    </svg>
                                </span>
                            </button>
                        </div>

                        <div className="date-cell">
                            {new Date(item.releaseDate).toLocaleDateString()}
                        </div>

                        <div className="date-cell">
                            {new Date(item.effectiveDate).toLocaleDateString()}
                        </div>

                        <div className="action-cell">
                            <button className="edit-btn" onClick={() => handleEdit(item)}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_14933_12173)">
                                        <path d="M4 20.0003H8L18.5 9.5003C19.0304 8.96987 19.3284 8.25045 19.3284 7.5003C19.3284 6.75016 19.0304 6.03074 18.5 5.5003C17.9696 4.96987 17.2501 4.67188 16.5 4.67188C15.7499 4.67187 15.0304 4.96987 14.5 5.5003L4 16.0003V20.0003Z" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M13.5 6.5L17.5 10.5" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_14933_12173">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </button>
                        </div>
                    </div>
                ))}
                {!versionsData || versionsData?.length === 0 &&
                    <div className="versions-empty">
                        <h3>No versions found</h3>
                        <p>There are currently no app versions configured.</p>
                    </div>
                }
            </div>
        </div>
    )
}

export default VersionsTable
